// extracted by mini-css-extract-plugin
export default {"blind_gift":"BlindGift_blind_gift__3MlRK","search":"BlindGift_search__giCyH","blind_list":"BlindGift_blind_list__f9mwO"};